import { EngineerValidateError, Stub } from '@/shared';
import { Button, chakra } from '@chakra-ui-kraud/react';
import { ErrorFillOperationProps } from './alert.types';

export const ErrorFillOperationAlert = ({
	handleCompleteOperationAgain,
	productTechMapNumber,
	variant = 'product',
}: ErrorFillOperationProps) => {
	const variantName = {
		assembly: 'сборочной',
		preform: 'заготовительной',
		product: '',
		rubber: '',
	};

	return (
		<Stub
			icon={<EngineerValidateError />}
			header="Ошибка заполнения операции"
			label={
				<p>
					Изменения по {variantName[variant]} маршрутной карте <strong>№{productTechMapNumber}</strong> не
					были сохранены. Попробуйте ещё раз.
				</p>
			}
			footer={
				<chakra.div width="100%">
					<Button variant="solid" width="100%" onClick={handleCompleteOperationAgain}>
						Заполнить еще раз
					</Button>
				</chakra.div>
			}
		/>
	);
};
